import { handleSelectQuestion } from '../_query_components/utils'
import { dictionary, tree } from './config.json'
export const selectQuestion = handleSelectQuestion(dictionary, tree)
